import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'app-medicion-cisterna',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  templateUrl: './medicion-cisterna.component.html',
  styleUrl: './medicion-cisterna.component.scss'
})
export class MedicionCisternaComponent implements OnInit {
  @Input() datosIniciales: any;
  formMedicion: FormGroup;

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal
  ) {
    this.formMedicion = this.fb.group({
      codigo: ['', Validators.required],
      volumen: ['', [Validators.required, Validators.min(1)]],
      volumen15: ['', [Validators.required, Validators.min(1)]]
    });
  }

  ngOnInit() {
    if (this.datosIniciales) {
      this.formMedicion.patchValue(this.datosIniciales);
    }
  }

  confirmar() {
    if (this.formMedicion.valid) {
      this.activeModal.close(this.formMedicion.value);
    }
  }

  cerrar() {
    this.activeModal.dismiss();
  }
}
